<template>
  <div class="details">
    <b-row class="p-10 pt-20">
      <b-col cols="1"></b-col>
      <b-col cols="10" v-if="eprosDetails && eprosDetails.length > 0">
        <div class="pt-15 card inner-card br-2" v-for="(epro, index) in eprosDetails.filter(eproDetail => eproDetail.id === selectedEpro.id)" :key="index">
          <div class="pl-20 pb-15">
            <b-row>
              <b-col cols="3" class="p-0">
                {{ epro.title }}
              </b-col>
              <b-col cols="4" v-if="epro.scheduler && epro.scheduler.milestones && epro.scheduler.milestones.length > 0">
                Milestones:
                <span v-for="(milestones, index) in epro.scheduler.milestones" :key="index">
                  {{ displayScreeningMilestones(milestones) }}
                  <span v-if="index + 1 < epro.scheduler.milestones.length">,</span>
                </span>
              </b-col>
            </b-row>
          </div>
          <div class="pl-20 pb-15">
            <div class="pb-10" v-if="epro.objective">
              <div class="content">
                Objective
              </div>
              <div class="header">
                {{ epro.objective }}
              </div>
            </div>
            <div class="pb-10" v-if="epro.therapeuticArea">
              <div class="content">
                Therapeutic area
              </div>
              <div class="header">
                {{ epro.therapeuticArea }}
              </div>
            </div>
            <div class="pb-10" v-if="epro.therapeuticIndication">
              <div class="content">
                Therapeutic indication
              </div>
              <div class="header">
                {{ epro.therapeuticIndication }}
              </div>
            </div>
            <div class="pb-10" v-if="epro.eProInfo.timeToComplete">
              <div class="content">
                Approximate time to complete
              </div>
              <div class="header">{{ epro.eProInfo.timeToComplete }} mins</div>
            </div>
            <b-row class="pb-10" v-if="epro.scheduler && epro.scheduler.milestones">
              <b-col v-if="epro.scheduler && epro.scheduler.milestones && epro.scheduler.milestones.length > 0" class="p-0">
                <div class="content">
                  To be completed at milestones
                </div>
                <div class="header">
                  <span v-for="(milestone, index) in epro.scheduler.milestones" :key="index">
                    {{ displayScreeningMilestones(milestone) }}
                    <span v-if="index + 1 < epro.scheduler.milestones.length">,</span>
                  </span>
                </div>
              </b-col>
              <b-col v-if="epro.scheduler.completionWindows">
                <div class="content">
                  Completion windows
                </div>
                <div class="header">{{ Object.values(epro.scheduler.completionWindows).join(", ") }}</div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="epro.scheduler && epro.scheduler.frequency">
              <b-col class="p-0">
                <div class="content">
                  Frequency
                </div>
                <div class="header">
                  {{ epro.scheduler.frequency.title }}
                </div>
              </b-col>
              <b-col v-if="epro.scheduler.completionWindow" class="p-0">
                <div class="content">
                  Completion window
                </div>
                <div class="header">{{ epro.scheduler.completionWindow > 1 ? epro.scheduler.completionWindow + " days" : epro.scheduler.completionWindow + " day" }} </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="epro.scheduler && epro.scheduler.isActivityOptional">
              <b-col class="p-0">
                <div class="content">
                  Activity is optional and will be excluded from the compliance report.
                </div>
                <div class="header">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="epro.scheduler && epro.scheduler.allowMultipleTimes">
              <b-col class="p-0">
                <div class="content">
                  Allow participants to repeat activity each time it is present
                </div>
                <div class="header">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="epro.scheduler && epro.scheduler.duration">
              <b-col cols="12" class="content p-0">
                Scheduled as follows
              </b-col>
              <b-col class="p-0" cols="4" v-for="(item, index) in epro.scheduler.duration" :key="index">
                <b-row class="p-0">
                  <b-col class="p-0" cols="3" v-if="item.startDay">
                    <div class="content">
                      Start Day
                    </div>
                    <div class="header">
                      {{ item.startDay }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="3" v-if="item.endDay">
                    <div class="content">
                      End Day
                    </div>
                    <div class="header">
                      {{ item.endDay }}
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="epro.scheduler && !(epro.scheduler.milestones && epro.scheduler.milestones.length > 0)">
              <b-col class="p-0" v-if="epro.scheduler.allowUntillDuration">
                <div class="content">
                  Available until the end of participant's study duration
                </div>
                <div class="header">
                  Yes
                </div>
              </b-col>
            </b-row>
            <b-row class="pb-10" v-if="epro.scheduler && epro.scheduler.reminders">
              <b-col cols="12" class="content p-0">
                Reminders
              </b-col>
              <b-col class="p-0" cols="12">
                <b-row class="p-0">
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      Day
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="6">
                    <div class="content">
                      Message
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      Time
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="content">
                      Notification type
                    </div>
                  </b-col>
                </b-row>
                <b-row class="p-0" v-for="(item, index) in epro.scheduler.reminders" :key="index">
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      {{ item.day }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="6">
                    <div class="header" v-if="item.message">
                      {{ item.message }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="header" v-if="item.time">
                      {{ item.time }}
                    </div>
                  </b-col>
                  <b-col class="p-0" cols="2">
                    <div class="header">
                      <span>Mobile</span>
                      <span v-if="item.emailToggle">, Email</span>
                      <span v-if="item.smsToggle">, SMS Text</span>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <div class="pl-20 pb-15 pr-20" v-if="epro.questions.length > 0">
            <div v-for="(question, index) in epro.questions" :key="index" class="pt-5">
              <div class="card read_only_question p-12">
                <b-row v-if="question.classType === 'Instruction' || question.type === 'SurveyInstruction' || question.type === 'ImageCapture' || question.type === 'SurveyCompletion'">
                  <b-col class="p-0">
                    <h5 class="instructionTitle fs-14" v-html="question.title"></h5>
                    <p class="question_body fs-12" v-html="question.information"></p>
                  </b-col>
                </b-row>
                <b-row class="content" v-if="question.classType !== 'Instruction' && question.type !== 'SurveyCompletion'">
                  <b-col class="p-0">
                    <h5 class="font-style fs-16">Question {{ question.questionNum }}</h5>
                    <p class="question_body" v-html="question.formattedBody"></p>
                    <div v-if="question.templateImageUrl">
                      <div class="row">
                        <div class="col-lg-6 col-md-6">
                          <p class="question_body fs-12" v-html="question.information"></p>
                          <div class="row">
                            <div class="col-lg-6 col-md-6 pl-0 pr-20" v-if="question.imageUrl">
                              <img class="img_size" :src="question.imageUrl" alt="Image" />
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-6">
                          <h5 class="instructionTitle fs-14">Template Image</h5>
                          <div class="row">
                            <div class="col-lg-6 col-md-6 pl-0 pr-20" v-if="question.templateImageUrl">
                              <img class="img_size" :src="question.templateImageUrl" alt="Image" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <p class="question_body fs-12" v-html="question.information"></p>
                      <div class="row">
                        <div class="col-lg-6 col-md-6 pl-0 pr-20" v-if="question.imageUrl">
                          <img class="img_size" :src="question.imageUrl" alt="Image" />
                        </div>
                      </div>
                    </div>
                    <div class="option-section lang-img-options" v-if="question.type.toLowerCase() === 'image'">
                      <div class="row justify-content-start">
                        <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
                          <div class="language-name">
                            {{ langOptionobj.languageName }}
                          </div>
                          <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
                            <div v-if="option.enabled">
                              <span v-if="question.subType.toLowerCase() === 'multi'">
                                <input type="checkbox" id="checkbox" disabled />
                              </span>
                              <span v-else>
                                <input type="radio" id="radio" disabled />
                              </span>
                              <img class="col-lg-2 img-size" :src="option.imageUrl" alt="Image" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <b-form-radio-group class="col-12 pl-0" :id="question.identifier" stacked v-model="question.sequence" :name="question.identifier" v-for="(choice, index) in question.options" :key="index" :disabled="true">
                      <b-col align-self="center" class="pl-0">
                        <b-form-radio type="radio" class="pl-0">
                          <span class="pl-20 text-align">{{ choice.formattedBody }}</span>
                        </b-form-radio>
                      </b-col>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import QlVideoUploadService from "@/services/ql-video-upload";
import localStorage from "@/services/localStorage";

const MODULE_NAME = "survey";
export default {
  name: "epro-details",
  data() {
    return {
      studyData: {},
      eprosDetails: [],
      selectedEpro: {},
      studyId: this.$route.params.studyId,
      eproId: this.$route.params.eproId,
      qlVideoUpload: null
    };
  },
  components: {},
  methods: {
    async geteprosDetails() {
      try {
        const geteprosDetails = await this.$api.getStudyeprosDetailsFact(this.studyId);
        this.eprosDetails = geteprosDetails.body;
        await this.eprosDetails.forEach((epro, eproIndex) => {
          if (epro.id === this.selectedEpro.id) {
            let questionCount = 1;
            epro.questions.forEach((question, questionIndex) => {
              if (question.classType !== "Instruction") {
                this.eprosDetails[eproIndex].questions[questionIndex].questionNum = questionCount;
                questionCount += 1;
              }
            });
            if (epro.questions) {
              // Removes unwanted scripts and styles texts
              this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(epro.questions, "information");
              this.qlVideoUpload.removeHarmfulScriptfromMultipleScreens(epro.questions, "formattedInformation");

              // Replaces old expired urls with new ones
              this.qlVideoUpload.replaceSignedVideoS3Url(epro.questions, "information", epro.participantVideos);
              this.qlVideoUpload.replaceSignedVideoS3Url(epro.questions, "formattedInformation", epro.participantVideos);
            }
          }
        });
      } catch (error) {
        this.$toastr.error(error.message || "Unable to fetch the instructions, questions and notifications.");
      }
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    displayScreeningMilestones(milestone) {
      if ((milestone !== '' || milestone !== null) && this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
        milestone -= this.studyData.screeningDuration;
      }
      return milestone;
    },
  },
  mounted() {
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    this.geteprosDetails();
    this.getStudyDetails();
    this.selectedEpro.id = this.eproId;
  }
};
</script>

<style scoped>
.language-name {
  color: #959fa4;
}
.img_size {
  width: 100%;
  height: 100%;
  max-width: 100px;
  max-height: 100px;
}
.lang-img-options .col-auto {
  margin-right: 66px !important;
}
.img-size {
  width: 100%;
  height: auto;
  float: none;
  padding: 10px 0 0;
  max-width: 120px;
  max-height: 120px;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
.read_only_question {
  background-color: #f5f8fa;
}
.question_color,
input {
  color: #666769;
  font-size: 14px;
}
.question_body {
  color: #959fa4;
}

.font-style {
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3498db;
}

.instructionTitle {
  color: #959fa4;
  word-break: break-word;
}
</style>
